import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSupport = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Livello_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 18 18",
	style: { enableBackground: "new 0 0 18 18" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		children: "\n	.st0{fill-rule:evenodd;clip-rule:evenodd;}\n"
	}), /* @__PURE__ */ _jsx("path", {
		className: "st0",
		d: "M9.1,0c3.6,0,5.7,2.1,6.3,5.5C17,5.8,18,7,18,8.5c0,1.6-1,2.8-2.9,3.1c-0.1,3.3-1,4.8-3.5,4.8l0,0 c-0.3,0.9-1.1,1.6-2.2,1.6c-1.5,0-2.3-1-2.3-2.3c0-1.2,0.9-2.3,2.3-2.3c1.2,0,2,0.7,2.3,1.7c1.7,0,2.2-1.3,2.2-4v-5 c0-2.5-2-4.7-4.8-4.7c-2.9,0-4.9,2.2-4.9,4.7v5.6H3.6C1.2,11.6,0,10.3,0,8.5c0-1.6,1-2.7,2.6-3C3.3,2.1,5.4,0,9.1,0z"
	})]
});
export default SvgSupport;
